import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/analytics';

/**
 * Automatically tracks page views on every route change.
 * Place inside <Router> in App.js.
 */
export default function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    // Strip dynamic IDs from paths for cleaner GA reports
    const cleanPath = location.pathname
      .replace(/\/groups\/\d+/, '/groups/:id')
      .replace(/\/events\/\d+/, '/events/:id')
      .replace(/\/heroes\/\d+/, '/heroes/:id')
      .replace(/\/chat\/\d+/, '/chat/:id')
      .replace(/\/channels\/\d+/, '/channels/:id')
      .replace(/\/community\/\d+/, '/community/:id')
      .replace(/\/b\/[^/]+/, '/b/:slug');

    trackPageView(cleanPath);
  }, [location]);

  return null;
}
